import { RouterProvider } from 'react-router-dom';
import { router } from '@/routes/router';

export function AppRoutes() {
  return <RouterProvider router={router} />;
}
